import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

const HeaderStyled = styled(Flexer.Parent)`
  flex: 0 1 4.8rem;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  color: #fff;
  width: 100%;
  background: var(--grey900);
`;

export default HeaderStyled;
